var re = {
    'capital': /[A-Z]/,
    'digit': /[0-9]/,
    'specialChar': /[ `!/@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/
};

export const capital = (str) => {
    if (typeof str !== 'string' || !str) return false; // Verifica que sea string y no esté vacío
    return /[A-Z]/.test(str);
  };
  
  export const digit = (str) => {
    if (typeof str !== 'string' || !str) return false; // Verifica que sea string y no esté vacío
    return /[0-9]/.test(str);
  };

export function specialChar(password) {
    return re.specialChar.test(password);
}